import { render, staticRenderFns } from "./PlatformMainMenu.vue?vue&type=template&id=48beb2d8&scoped=true"
import script from "./PlatformMainMenu.vue?vue&type=script&lang=js"
export * from "./PlatformMainMenu.vue?vue&type=script&lang=js"
import style0 from "./PlatformMainMenu.vue?vue&type=style&index=0&id=48beb2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48beb2d8",
  null
  
)

export default component.exports